module.exports = __webpack_public_path__ + "static/img/inis.5f32023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inis.png
// module id = Ih7Q
// module chunks = 1